// extracted by mini-css-extract-plugin
module.exports = {"root":"GOghWRuy","title":"GksUX9x4"};